import {Component, HostListener, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {GetFormsService} from '../../../shared/services/get-forms.service';
import {GetConfigSharedService} from '../../../shared/services/get-config-shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../../shared/reducers';
import {Observable, Subscription} from 'rxjs';
import {BillingProduct, Product} from '../../../shared/models/product';
import {Company} from '../../../company/models/company';
import {Contract} from '../../models/contract';
import * as fromContracts from '../../reducers';
import * as fromCompanies from '../../../company/reducers';
import * as fromContract from '../../reducers';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../../shared/models/config';
import {LoadBillingProductsAction} from '../../../shared/actions/billing-product';
import {Rules} from '../../models/rules';
import {LanguageText} from '../../models/language-text';
import {
  LanguageIdClearAction,
  LanguageIdUpdateAction,
  LoadGlobalLanguageTextsAction,
  LoadLanguageTextsAction,
  LoadReplacementLanguageTextsAction
} from '../../actions/language-texts-load';
import * as _ from 'lodash';
import {debounceTime} from 'rxjs/operators';
import {LanguageTextsUpdateAction} from '../../actions/language-text-update';
import * as moment from 'moment';
import {DataConfig} from '../../../shared/models/tabs-data';
import {CompanyClearAction} from '../../../company/actions/company-load';

@Component({
  selector: 'storever-contract-language-text',
  templateUrl: './contract-language-text.component.html',
  styleUrls: ['./contract-language-text.component.css']
})
export class ContractLanguageTextComponent implements OnInit , OnDestroy {
  dataConfig: DataConfig;
  product$: Observable<Product[]>;
  rules$: Observable<Rules[]>;
  rules: Rules[];
  product: Product[];
  billingProduct$: Observable<BillingProduct[]>;
  billingProduct: BillingProduct[];
  currentCompany$: Observable<Company>;
  currentCompany: Company;
  currentContract$: Observable<Contract>;
  currentContract: Contract;
  fee$: Observable<LanguageText[]>;
  languageID$: Observable<number>;
  fee: LanguageText[];
  global$: Observable<LanguageText[]>;
  global: LanguageText[];
  replacement$: Observable<LanguageText[]>;
  replacement: LanguageText[];
  form: FormGroup;
  formFeeConfig: GroupConfig;
  formGlobalConfig: GroupConfig;
  formReplacementConfig: GroupConfig;
  companyLanguageId: number;
  productSapCode: string;
  startDate: Date;
  endDate: Date;
  invoicingCode: string [];
  productId: number;
  productName: string;
  isEdit = true;
  isAdd = false;
  isCollapsed = false;
  private sub$: Subscription;
  private subscriptions = [];
  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private storeContract: Store<fromContracts.AppState>,
              private storeCompany: Store<fromCompanies.AppState>,
              private store: Store<fromShared.AppState>) { }

  ngOnInit(): void {
    this.store.dispatch(new LoadBillingProductsAction());
    this.form = this.dataConfig.form;
    this.formFeeConfig = this.getConfigSharedService.getConfigFeeLanguageTexts();
    this.formGlobalConfig = this.getConfigSharedService.getConfigGlobalLanguageTexts();
    this.formReplacementConfig = this.getConfigSharedService.getConfigReplacementLanguageTexts();
    this.currentCompany$ = this.storeCompany.pipe(select(fromCompanies.selectors.getCompany));
    this.currentContract$ = this.storeContract.pipe(select(fromContract.selectors.getCurrentContract));
    this.rules$ = this.storeContract.pipe(select(fromContract.selectors.getRules));
    this.product$ = this.store.pipe(select(fromShared.selectors.getProducts));
    this.billingProduct$ = this.store.pipe(select(fromShared.selectors.getBillingProducts));
    this.fee$ = this.storeContract.pipe(select(fromContract.selectors.getFeeLanguageTexts));
    this.global$ = this.storeContract.pipe(select(fromContract.selectors.getGlobalLanguageTexts));
    this.replacement$ = this.storeContract.pipe(select(fromContract.selectors.getReplacementLanguageTexts));
    this.languageID$ = this.storeContract.pipe(select(fromContract.selectors.getLanguageID));
    this.loadDate();
    this.getData();
    // this.form.valueChanges.pipe(debounceTime(2000)).subscribe(data => {
    //   this.form.markAsDirty();
    // })
  }
  getData(): void {
    // console.log('getData')
    this.sub$ = this.currentContract$.subscribe(data => { if ( data) {
      this.currentContract = data;
      this.calculateDates(this.currentContract.recurrence)
      // console.log('currentContract' , this.product)
      this.storeContract.dispatch(new LoadGlobalLanguageTextsAction(
        'languageKeys=LOC,LOCDAY,LOCDAYMON,CONTRACT_' + data.id + '_LOC,CONTRACT_' + data.id + '_LOCDAY,CONTRACT_' + data.id + '_LOCDAYMON'
      ));
      this.productId = data.productID;
      // console.log('--------------------------------' , this.product)
      // console.log('--------------------------------' , this.currentContract)
      if (this.product && this.product.length > 0) {
        for (let p = 0; p < this.product.length; ++p) {
          if (this.product[p].id === this.currentContract.productID) {
            this.productName = this.product[p].service.name.toUpperCase();
          }
        }
        // console.log('--------------------------------')
        // console.log(this.productId, this.product)
        // console.log(this.getProductSap(this.productId, this.product))
        this.storeContract.dispatch(new LoadReplacementLanguageTextsAction(
          'languageKeys=' +  this.getProductSap(this.productId, this.product) + ',' +  this.getProductSap(this.productId, this.product) +
          '_LOC' + ',SERVICE_' + this.productName + ',' + this.getRecurrence(data.recurrence) +  ',CONTRACT_' + data.id + '_' +
          this.getProductSap(this.productId, this.product) + ',CONTRACT_' +
          data.id  + '_' + this.getProductSap(this.productId, this.product) +
          '_LOC' + ',CONTRACT_' + data.id + '_' + 'SERVICE_' + this.productName + ',' +
          'CONTRACT_' + data.id + '_' + this.getRecurrence(data.recurrence)
        ));
      }
     // console.log(this.billingProduct , this.currentContract)
      if (this.billingProduct && this.billingProduct.length > 0) {
        this.storeContract.dispatch(new LoadLanguageTextsAction(
          'languageKeys=' + this.getBillingProductInvoicingCode(this.billingProduct, this.currentContract.id).join()))
      }

    }});
    this.subscriptions.push(this.sub$);
    this.sub$ = this.rules$.subscribe(data => { if ( data) { this.rules = data;  }});
    this.subscriptions.push(this.sub$);
    this.sub$ = this.currentCompany$.subscribe(data => {
      if ( data) {

      this.currentCompany = data;
      this.companyLanguageId = data.language.id
      this.setGlobal(this.companyLanguageId , this.global , this.currentContract.id)
      this.setReplacement(this.companyLanguageId, this.replacement, this.currentContract.id)
    }});
    this.subscriptions.push(this.sub$);
    this.sub$ =  this.product$.subscribe(data => { if ( data) {
      // console.log('product$')
      this.product = data;
      if (this.currentContract && this.currentContract.productID) {
        // console.log('--------------------------------' , this.product)
        // console.log('--------------------------------' , this.currentContract)
        if (this.product && this.product.length > 0) {
            for (let p = 0; p < this.product.length; ++p) {
              if (this.product[p].id === this.currentContract.productID) {
                this.productName = this.product[p].service.name.toUpperCase();
              }
            }
        }

        this.setFee(this.companyLanguageId , this.fee , this.currentContract.id)
      }
      // console.log(this.billingProduct , this.currentContract)
      if (this.currentContract && this.billingProduct && this.billingProduct.length > 0) {
       // console.log('product$ if')
        this.storeContract.dispatch(new LoadLanguageTextsAction(
          'languageKeys=' + this.getBillingProductInvoicingCode(this.billingProduct, this.currentContract.id).join()))


      }
      if (this.productId && this.product) {
        // console.log('--------------------------------')
        // console.log(this.productId, this.product)
        // console.log(this.getProductSap(this.productId, this.product))
        this.storeContract.dispatch(new LoadReplacementLanguageTextsAction(
          'languageKeys=' + this.getProductSap(this.productId, this.product) + ',' + this.getProductSap(this.productId, this.product) +
          '_LOC' + ',SERVICE_' + this.productName + ',' + this.getRecurrence(this.currentContract.recurrence) + ',CONTRACT_' + this.currentContract.id + '_' +
          this.getProductSap(this.productId, this.product) + ',CONTRACT_' +
          this.currentContract.id + '_' + this.getProductSap(this.productId, this.product) +
          '_LOC' + ',CONTRACT_' + this.currentContract.id + '_' + 'SERVICE_' + this.productName + ',' +
          'CONTRACT_' + this.currentContract.id + '_' + this.getRecurrence(this.currentContract.recurrence)
        ));
      }
      this.getProductSap(this.productId, this.product);
    }});
    this.subscriptions.push(this.sub$);
    this.sub$  = this.billingProduct$.subscribe(data => {
      if ( data) {
        this.billingProduct = data;
       // console.log(this.billingProduct , this.currentContract)
        if (this.currentContract && this.billingProduct.length > 0 && this.productName) {
          this.storeContract.dispatch(new LoadLanguageTextsAction(
            'languageKeys=' + this.getBillingProductInvoicingCode(this.billingProduct, this.currentContract.id).join()))
        }

      }});
    this.subscriptions.push(this.sub$);
    this.sub$ =  this.fee$.pipe(debounceTime(1000)).subscribe(data => { if ( data) {
      this.fee = data;
      if ( this.billingProduct.length > 0  && this.companyLanguageId && this.productName) {
        this.setFee(this.companyLanguageId , this.fee , this.currentContract.id)
      }


    }});
    this.subscriptions.push(this.sub$);
    this.sub$ = this.global$.subscribe(data => { if ( data) {
      this.global = data;
      this.setGlobal(this.companyLanguageId , this.global , this.currentContract.id)
    }});
    this.subscriptions.push(this.sub$);
    this.sub$ = this.replacement$.subscribe(data => {
      if ( data && this.currentContract) {
        this.replacement = data;
        this.setReplacement(this.companyLanguageId, this.replacement, this.currentContract.id)
      }
    });
    this.subscriptions.push(this.sub$);
    this.sub$ = this.languageID$.subscribe(data => {
      if ( data) {
        this.updateLanguage(data);
      } else {
       // this.updateLanguage(1);
      }
    });


  }
  getBillingProductInvoicingCode(value: BillingProduct[] , contractId: number): string[]  {
    this.formFeeConfig = this.getConfigSharedService.getConfigFeeLanguageTexts();
    this.invoicingCode = [];
     // console.log('getBillingProductInvoicingCode' , this.rules) //options : key: "widgetService" 2030-01-01T00:00:00
   //  console.log(this.rules , value)
    for (let p = 0; p < this.rules.length; ++p) {
      if (this.rules[p].options.length > 0) {
        for (let pp = 0; pp < this.rules[p].options.length; ++pp) {
          for (let ppp = 0; ppp < value.length; ++ppp) {
          // console.log(this.rules[p].options[pp] , value[ppp].code)
           if (this.rules[p].options[pp].key === value[ppp].code) {
             // tslint:disable-next-line:typedef
             const item = _.filter(this.invoicingCode, function  ( o) {
               return o ===  value[ppp].invoicingCode;
             })
          //   console.log(item)
             if (item.length === 0) {
               this.invoicingCode.push(value[ppp].invoicingCode);
               this.invoicingCode.push('CONTRACT_' + contractId + '_' + value[ppp].invoicingCode);
               let controlName = value[ppp].code;
               if (  controlName === '4GRouterManagementLicense') {
                 controlName = 'routerManagementLicense'
               }

               // @ts-ignore
               // tslint:disable-next-line:no-any
               const isControlitem = _.findIndex(this.formFeeConfig.config, function(o: string): any { return o.controlName[0] === controlName; });
              // console.log(controlName , isControlitem)
               if (isControlitem === -1) {
                 this.formFeeConfig.config.push(
                   {
                     type: 'input',
                     label: value[ppp].code,
                     controlName: [controlName],
                     placeholder: value[ppp].code,
                     presentation: 'edit',
                     options: {
                       show: true,
                       labelShowInDetail: true
                     }
                   },
                 )
               }
             }
           }
          }
        }
      }
    }
    this.invoicingCode.push('MMB' + this.productName + '-MAINT');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'MMB' + this.productName + '-MAINT');
    this.invoicingCode.push('MATERIALLOCATION');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'MATERIALLOCATION');
    this.invoicingCode.push('MMBAUDIO-MUSICSERVICE');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'MMBAUDIO-MUSICSERVICE');
    this.invoicingCode.push('MMBVIDEO-SOFTSERVICE');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'MMBVIDEO-SOFTSERVICE');
    this.invoicingCode.push('MP-PROJECTMANAG');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'MP-PROJECTMANAG');
    this.invoicingCode.push('PRE-' + this.productName + '');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'PRE-' + this.productName + '');
    this.invoicingCode.push('PROD-' + this.productName + '');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'PROD-' + this.productName + '');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'DIVPercent');
    this.invoicingCode.push('DIVPercent');
    this.invoicingCode.push('CONTRACT_' + contractId + '_' + 'DIV');
    this.invoicingCode.push('DIV');
    return this.invoicingCode;
  }
  // tslint:disable-next-line:no-any
  onChange(event: any): void {
    this.companyLanguageId  = Number(event.target.value);
    this.storeContract.dispatch(new LanguageIdUpdateAction(this.companyLanguageId));
    this.setReplacement(this.companyLanguageId, this.replacement, this.currentContract.id)
    this.setGlobal(this.companyLanguageId , this.global , this.currentContract.id)
    this.setFee(this.companyLanguageId , this.fee , this.currentContract.id)
  }
  updateLanguage(event: number): void {
    this.companyLanguageId  = Number(event);
   // this.storeContract.dispatch(new LanguageIdUpdateAction(this.companyLanguageId));
    this.setReplacement(this.companyLanguageId, this.replacement, this.currentContract.id)
    this.setGlobal(this.companyLanguageId , this.global , this.currentContract.id)
    this.setFee(this.companyLanguageId , this.fee , this.currentContract.id)
  }
  setFee(languageId: number  , fee: LanguageText[] , contractId: number): void {
    if ( fee) {
      for (let ii = 0; ii < this.billingProduct.length; ++ii) {
        const invoicingCode = this.billingProduct[ii].invoicingCode;
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'softwareService');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'musicService');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'materialLocation');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'projectManagement');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'DIV');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'DIVPercent');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'braketRental');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'monitorRental');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'onlineMaintenance');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'remoteManagement');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'SIMDataService');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'SSLCertificateRenewal');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'widgetService');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'audioPlayerRental');
        this.performFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , 'videoPlayerRental');
        this.perform4GRouterFee(this.billingProduct[ii] , invoicingCode , contractId , languageId , fee , '4GRouterManagementLicense');

      }
      this.performSpecialFee( 'MMB' + this.productName + '-MAINT' , contractId , languageId , fee , 'maint');
      this.performSpecialFee( 'PRE-' + this.productName + '' , contractId , languageId , fee , 'setup');
      this.performSpecialFee('PROD-' + this.productName + '' , contractId , languageId , fee , 'prod');
    }
  }
  performFee(billingProduct: BillingProduct , invoicingCode: string , contractId: number, languageId: number , fee: LanguageText[], label: string): void {
    if (billingProduct.code === label) {
      // console.log(invoicingCode , languageId )
      // tslint:disable-next-line:typedef
      let feeItem = _.filter(fee, function  ( o) {
        return o.key ===  'CONTRACT_' + contractId + '_' + invoicingCode  && o.languageID === languageId;
      })
      // console.log('feeItem 1' , feeItem )
      if (feeItem.length > 0) {
        this.form.get(['feesForm', label]).patchValue(feeItem[0].value)
        this.form.markAsPristine();
      } else {
        // tslint:disable-next-line:typedef
        feeItem = _.filter(fee, function  ( o) {
          return o.key ===  invoicingCode  && o.languageID === languageId;
        })
       // console.log('feeItem 2' , feeItem )
        if (feeItem.length > 0) {
          this.form.get(['feesForm', label]).patchValue(feeItem[0].value)
          this.form.markAsPristine();
        } else {
          this.form.get(['feesForm', label]).setValidators([]);
          this.form.get(['feesForm', label]).updateValueAndValidity();
        }
       // console.log('form 2' , this.form.get(['feesForm', label]) )
      }
    }
  }
  perform4GRouterFee(billingProduct: BillingProduct , invoicingCode: string ,
                     contractId: number, languageId: number , fee: LanguageText[], label: string): void {
    if (billingProduct.code === label) {
     // console.log(invoicingCode , languageId )
      // tslint:disable-next-line:typedef
      let feeItem = _.filter(fee, function  ( o) {
        return o.key ===  'CONTRACT_' + contractId + '_' + invoicingCode  && o.languageID === languageId;
      })
      if (feeItem.length > 0) {
        this.form.get(['feesForm', 'routerManagementLicense']).patchValue(feeItem[0].value)
      } else {
        // tslint:disable-next-line:typedef
        feeItem = _.filter(fee, function  ( o) {
          return o.key ===  invoicingCode  && o.languageID === languageId;
        })
        if (feeItem.length > 0) {
          this.form.get(['feesForm', 'routerManagementLicense']).patchValue(feeItem[0].value)
        }
        else {
          this.form.get(['feesForm', 'routerManagementLicense']).setValidators([]);
          this.form.get(['feesForm', 'routerManagementLicense']).updateValueAndValidity();
        }

      }
    }
    this.form.markAsPristine();
  }
  performSpecialFee(invoicingCode: string , contractId: number, languageId: number , fee: LanguageText[], label: string): void {

      // console.log(invoicingCode , fee )
      // tslint:disable-next-line:typedef
      let feeItem = _.filter(fee, function  ( o) {
        return o.key ===  'CONTRACT_' + contractId + '_' + invoicingCode  && o.languageID === languageId;
      })
      if (feeItem.length > 0) {
        this.form.get(['feesForm', label]).patchValue(feeItem[0].value)
      } else {
        // tslint:disable-next-line:typedef
        feeItem = _.filter(fee, function  ( o) {
          return o.key ===  invoicingCode  && o.languageID === languageId;
        })
        // console.log(feeItem)
        if (feeItem.length > 0) {
          this.form.get(['feesForm', label]).patchValue(feeItem[0].value)
        }
        else {
          this.form.get(['feesForm', label]).setValidators([]);
          this.form.get(['feesForm', label]).updateValueAndValidity();
        }

      }
      this.form.markAsPristine();
  }
  setReplacement(languageId: number  , replacement: LanguageText[] , contractId: number): void {
    // console.log(languageId , replacement)
    let recurrenceLab;
    let product;
    let productSap;
    let service;
    if ( replacement) {

      for (let i = 0; i < replacement.length; ++i) {
        if ( replacement[i].key.search('RECURRENCE')  === 0 && !recurrenceLab && replacement[i].languageID === languageId) {
          recurrenceLab = replacement[i].value

        }
        if ( replacement[i].key  === this.productSapCode && !productSap && replacement[i].languageID === languageId) {
          productSap = replacement[i].value
        }
        if ( replacement[i].key  === this.productSapCode + '_LOC' && !product && replacement[i].languageID === languageId) {
          product = replacement[i].value
        }
        if ( replacement[i].key  === 'SERVICE_' + this.productName  && !service && replacement[i].languageID === languageId) {
          service = replacement[i].value
        }
        if ( replacement[i].key.search( 'CONTRACT_' + contractId + '_' + 'RECURRENCE')  === 0  && replacement[i].languageID === languageId) {
          recurrenceLab = replacement[i].value
        }
        if ( replacement[i].key  ===  'CONTRACT_' + contractId + '_' + this.productSapCode  && replacement[i].languageID === languageId) {
          productSap = replacement[i].value
        }
        if ( replacement[i].key  ===  'CONTRACT_' + contractId + '_' + this.productSapCode + '_LOC'  && replacement[i].languageID === languageId) {
          product = replacement[i].value
        }
        if ( replacement[i].key  ===  'CONTRACT_' + contractId + '_' + 'SERVICE_' + this.productName && replacement[i].languageID === languageId) {
          service = replacement[i].value
        }
      }
      this.form.get(['replacement']).patchValue({
        recurrence: recurrenceLab,
        product: productSap,
        productLoc: product,
        service: service,
      })
      this.form.markAsPristine();
    }
  }

  getRecurrence(recurrence: number   ): string {
    switch (recurrence) {
      case 1: return 'RECURRENCE_M'; break;
      case 3: return 'RECURRENCE_Q'; break;
      case 6: return 'RECURRENCE_S'; break;
      case 12: return 'RECURRENCE_Y'; break;
      case 24: return 'RECURRENCE_2Y'; break;
      case 36: return 'RECURRENCE_3Y'; break;
      case 48: return 'RECURRENCE_4Y'; break;
      case 60: return 'RECURRENCE_5Y'; break;
      case 72: return 'RECURRENCE_6Y'; break;
      case 84: return 'RECURRENCE_7Y'; break;
      case 96: return 'RECURRENCE_8Y'; break;
      case 108: return 'RECURRENCE_9Y'; break;
      case 120: return 'RECURRENCE_10Y'; break;
      case 0: return 'RECURRENCE_Y'; break;
    }
  }
  getProductSap(productId: number  , product: Product[] ): string {

    if (product && product.length > 0 &&  productId) {
      for (let j = 0; j < product.length; ++j) {
        if (product[j].id === productId) {
          this.productSapCode = product[j].sapCode;
        }
      }
    }
    return this.productSapCode;
  }
  setGlobal(languageId: number  , global: LanguageText[] , contractId: number): void {
    // console.log(languageId , global)
    let LOC;
    let LOCDAY;
    let LOCDAYMON
    if ( global) {

        for (let i = 0; i < global.length; ++i) {
        if ( global[i].key  === 'LOC' && !LOC && global[i].languageID === languageId) {
          LOC = global[i].value
        }
        if ( global[i].key  === 'LOCDAY' && !LOCDAY && global[i].languageID === languageId) {
            LOCDAY = global[i].value
        }
        if ( global[i].key  === 'LOCDAYMON' && !LOCDAYMON && global[i].languageID === languageId) {
          LOCDAYMON = global[i].value
        }
        if ( global[i].key  === 'CONTRACT_' + contractId + '_LOC' && global[i].languageID === languageId) {
            LOC = global[i].value
          }
        if ( global[i].key  === 'CONTRACT_' + contractId + '_LOCDAY' && global[i].languageID === languageId) {
            LOCDAY = global[i].value
          }
        if ( global[i].key  === 'CONTRACT_' + contractId + '_LOCDAYMON' && global[i].languageID === languageId) {
            LOCDAYMON = global[i].value
          }
        }
        this.form.get(['globalForm']).patchValue({
          loc: LOC,
          locDay: LOCDAY,
          locDayMon: LOCDAYMON
        })
        this.form.markAsPristine();
    }
  }
  loadDate(): void {
    // this.storeContract.dispatch(new LoadLanguageTextsAction());

    // this.storeContract.dispatch(new LoadReplacementLanguageTextsAction());
  }

  saveFee(): void {
    const resp = this.form.get(['feesForm']).value;
    const contID = this.currentContract.id;
    const lgID = this.companyLanguageId;

    // console.log(resp)

    const languageText = []
    if (resp.softwareService) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'MMBVIDEO-SOFTSERVICE' , value: resp.softwareService , languageID: lgID});
    }
    if (resp.musicService) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'MMBAUDIO-MUSICSERVICE' , value: resp.musicService , languageID: lgID});
    }
    if (resp.materialLocation) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'MATERIALLOCATION' , value: resp.materialLocation , languageID: lgID});
    }
    if (resp.projectManagement) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'MP-PROJECTMANAG' , value: resp.projectManagement , languageID: lgID});
    }
    if (resp.DIV) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'DIV' , value: resp.DIV , languageID: lgID});
    }
    if (resp.DIVPercent) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'DIVPercent' , value: resp.DIVPercent , languageID: lgID});
    }
    if (resp.onlineMaintenance) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'onlineMaintenance' , value: resp.onlineMaintenance , languageID: lgID});
    }
    if (resp.braketRental) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'braketRental' , value: resp.braketRental , languageID: lgID});
    }
    if (resp.monitorRental) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'monitorRental' , value: resp.monitorRental , languageID: lgID});
    }
    if (resp.remoteManagement) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'remoteManagement' , value: resp.remoteManagement , languageID: lgID});
    }
    if (resp.SIMDataService) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'SIMDataService' , value: resp.SIMDataService , languageID: lgID});
    }
    if (resp.SSLCertificateRenewal) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'SSLCertificateRenewal' , value: resp.SSLCertificateRenewal , languageID: lgID});
    }
    if (resp.widgetService) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'widgetService' , value: resp.widgetService , languageID: lgID});
    }
    if (resp.audioPlayerRental) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'audioPlayerRental' , value: resp.audioPlayerRental , languageID: lgID});
    }
    if (resp.videoPlayerRental) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'videoPlayerRental' , value: resp.videoPlayerRental , languageID: lgID});
    }
    if (resp.routerManagementLicense) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + '4GRouterManagementLicense' , value: resp.routerManagementLicense , languageID: lgID});
    }
    if (resp.maint) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'MMB' + this.productName + '-MAINT' , value: resp.maint , languageID: lgID});
    }
    if (resp.setup) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'PRE-' + this.productName + '' , value: resp.setup , languageID: lgID});
    }
    if (resp.prod) {
      languageText.push({key: 'CONTRACT_' + contID + '_' + 'PROD-' + this.productName + '' , value: resp.prod , languageID: lgID});
    }

    this.storeContract.dispatch(new  LanguageTextsUpdateAction(languageText))
    this.form.markAsPristine();
  }
  undoFee(): void {
    this.setFee(this.companyLanguageId , this.fee , this.currentContract.id)
    this.form.markAsPristine();
  }
  saveGlobal(): void {
    const resp = this.form.get(['globalForm']).value;

    this.storeContract.dispatch(new  LanguageTextsUpdateAction(
      [
        {key: 'CONTRACT_' + this.currentContract.id + '_LOC' , value: resp.loc , languageID: this.companyLanguageId},
        {key: 'CONTRACT_' + this.currentContract.id + '_LOCDAY', value: resp.locDay , languageID: this.companyLanguageId},
        {key:  'CONTRACT_' + this.currentContract.id + '_LOCDAYMON' , value: resp.locDayMon , languageID: this.companyLanguageId},

      ]
    ))
    this.form.markAsPristine();
  }
  undoGlobal(): void {
    this.setGlobal(this.companyLanguageId , this.global , this.currentContract.id)
  }
  replacementSave(): void {
    const resp = this.form.get(['replacement']).value;

    // tslint:disable-next-line:typedef
    const recurrenceName = _.filter(this.replacement, function  ( o) {
      return o.key.search(  'RECURRENCE') !== -1;
    })
    // console.log(this.replacement)
    this.storeContract.dispatch(new  LanguageTextsUpdateAction(
      [
        {key: 'CONTRACT_' + this.currentContract.id + '_' + this.productSapCode , value: resp.product , languageID: this.companyLanguageId},
        {key: 'CONTRACT_' + this.currentContract.id + '_' + this.productSapCode + '_LOC' , value: resp.productLoc , languageID: this.companyLanguageId},
        {key:  'CONTRACT_' + this.currentContract.id + '_' + 'SERVICE_' + this.productName , value: resp.service , languageID: this.companyLanguageId},
        {key: 'CONTRACT_' + this.currentContract.id + '_' + recurrenceName[0].key , value: resp.recurrence , languageID: this.companyLanguageId},

      ]
    ))
    this.form.markAsPristine();
  }
  replacementUndo(): void {
    this.setReplacement(this.companyLanguageId, this.replacement, this.currentContract.id)
  }

  // @HostListener('window:beforeunload')
  // canDeactivate(): boolean {
  //   console.log('canDeactivate' , this.form.dirty)
  //   let isDeactivable = true;
  //   if (this.form && this.form.dirty) {
  //         console.log('canDeactivate')
  //         isDeactivable = false;
  //       }
  //   return isDeactivable;
  // }
  // tslint:disable-next-line:no-any
  calculateDates( recurrence: number): void {
    const currentYear = new Date().getFullYear();

    // Initialize the start date to the first of January of the current year
    const start = new Date(currentYear, 0, 1); // JavaScript months are 0-indexed (0 is January)
   //  const end = new Date(start);

    // switch (recurrence) {
    //   case 1:
    //     end.setMonth(end.getMonth() + 1);
    //     break;
    //   case 3:
    //     end.setMonth(end.getMonth() + 3);
    //     break;
    //   case 6:
    //     end.setMonth(end.getMonth() + 6);
    //     break;
    //   case 12:
    //     end.setFullYear(end.getFullYear() + 1);
    //     break;
    //   default:
    //     throw new Error('Invalid recurrence pattern');
    // }

    this.startDate = start;
    this.endDate =  new Date(currentYear, 12, 0);
  }

  // tslint:disable-next-line:no-any
  transformFormInLabel(value: any): string {
    if (value && value.value) {
      let label = value.value;
      label = label.replace('{service}', this.form.get(['replacement', 'service']).value);
      label = label.replace('{product_loc}', this.form.get(['replacement', 'productLoc']).value);
      label = label.replace('{product}', this.form.get(['replacement', 'product']).value);
      label = label.replace('{start}',  moment(this.startDate).format('YYYY-MM-DD'));
      label = label.replace('{end}', moment(this.endDate).format('YYYY-MM-DD'));
      return label;
    }
  }

  ngOnDestroy(): void {
   // console.log('ngOnDestroy')
    this.storeCompany.dispatch(new CompanyClearAction());
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }


  }
}
